var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"section-title"},[_vm._v(" Usługa realizowana z partnerem ")])]),_c('div',{staticClass:"partner-logo"},[_c('img',{attrs:{"src":require("../../../assets/images/logo-autopay.svg"),"width":"120"}})])])
}]

export { render, staticRenderFns }